import { Directive, ElementRef, HostListener, Input, Renderer2 } from '@angular/core';
import { NgForm } from '@angular/forms';
import jump from 'jump.js';

@Directive({
  selector: '[ngScrollToFirstInvalid]',
  standalone: false
})
export class NgxScrollToFirstInvalidDirective {
  @Input() formGroup: NgForm;

  constructor(private readonly el: ElementRef, private readonly _renderer: Renderer2) {}

  markFormGroupTouched(formGroup) {
    (Object as any).values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }

  scrollToElement(element: HTMLElement) {
    let clientHeaderHeight = 0;
    if (this._renderer) {
      const stickyTop: HTMLElement = this._renderer.selectRootElement('.sticky-top', true);
      clientHeaderHeight = stickyTop.clientHeight;
    }
    jump(element, {
      offset: -(clientHeaderHeight + 200)
    });
  }

  @HostListener('submit', ['$event'])
  onSubmit(event: any) {
    event.preventDefault();
    if (!this.formGroup.valid) {
      this.markFormGroupTouched(this.formGroup);

      const formControlInvalid = this.el.nativeElement.querySelector('.ng-invalid');

      if (formControlInvalid) {
        return this.scrollToElement(formControlInvalid);
      } else {
        // The first element is the global form and here we are looking for the first nested form
        const formGroupInvalid = this.el.nativeElement.querySelectorAll('form .ng-invalid');
        if (formGroupInvalid && formGroupInvalid.length) {
          return this.scrollToElement(formGroupInvalid[0]);
        }
      }

      return this.scrollToElement(this.el.nativeElement);
    }
  }
}
